(function ($, window, document) {
  $(function () {
    const header = $("header")[0];
    if (header) {
      $("header .nav-toggle").on("click", function (e) {
        e.preventDefault();
        $(header).toggleClass("opened");
      });
    }

    if ($("#flash-notice").length) {
      var $flash = $("#flash-notice");
      var flashMessage = $.trim($flash.find(".alert-body").text());

      if (flashMessage) {
        $flash.appendTo("body");
        window.setTimeout(function () {
          $flash.addClass("in");
        }, 50);

        window.setTimeout(function () {
          $flash.alert("close");
        }, 8000);
      }
    }

    $("#phone-number").mask("(000) 000-0000");
    // $('input, textarea').placeholder();

    // same rules as bv's reverse phone
    $.validator.addMethod(
      "customphone",
      function (phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, "");
        return (
          this.optional(element) ||
          (phone_number.length > 9 &&
            phone_number.match(
              /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/,
            ))
        );
      },
      "Please enter a valid phone number. e.g. (212) 555-6789",
    );

    $("#phone-form").validate({
      ignore: ".ignore",
      rules: {
        phone_number: {
          required: true,
          customphone: true,
        },
      },
      messages: {
        phone_number: "Please enter a valid phone number. e.g. (212) 555-6789",
      },
      showErrors: function (errorMap, errorList) {
        $.each(this.successList, function (index, value) {
          return $(value).popover("hide");
        });
        return $.each(errorList, function (index, value) {
          var _popover;
          _popover = $(value.element).popover({
            trigger: "manual",
            placement: "bottom",
            content: value.message,
            template:
              '<div class="popover "><div class="arrow"></div><div class="popover-inner has-error"><div class="popover-content control-label"><p></p></div></div></div>',
          });
          _popover.data("bs.popover").options.content = value.message;
          return $(value.element).popover("show");
        });
      },
      submitHandler: function (form) {
        const num = $("#phone-number")
          .val()
          .replace(/[^0-9]/g, "");

        if (num.length > 0) {
          const currentPath = window.location.pathname;
          const phonePattern = /^\/phone\/\d+\/\d+\/\d+\/?$/;

          if (phonePattern.test(currentPath)) {
            window.location.href =
              "https://www.numberguru.com/lp/d8937f/2/loading?aff_sub=sb_btn&phone=" +
              num;
          } else {
            window.location.href = $(form).attr("action") + num + "/";
          }
        }
      },
    });

    $("[data-acsb='trigger']").click(function () {
      var loaded = sessionStorage.getItem("acsb_loaded");
      if (loaded) {
        return;
      }
      sessionStorage.setItem("acsb_loaded", true);
      window.location.href = window.location.href + "#showacsb";
      document.location.reload();
    });

    $("input.select-all").click(function () {
      var checked = this.checked;
      $("input.select-item").each(function (index, item) {
        item.checked = checked;
      });
    });

    $("input.select-item").click(function () {
      checkSelected();
    });

    function checkSelected() {
      var all = $("input.select-all")[0];
      var total = $("input.select-item").length;
      var len = $("input.select-item:checked:checked").length;
      all.checked = len === total;
    }

    $("#bsubmit").click(function () {
      $("#bcount").text($("input.select-item:checked:checked").length);
    });

    $("#bmsubmit").click(function () {
      $("#bform").submit();
    });
  });
})(jQuery, window, document);
